import { ResourceKey } from "providers";
import React from "react";

import { FormContextHelp } from "./FormContextHelp";

interface EditFormLabelProps {
  label?: ResourceKey;
  contextHelp?: ResourceKey;
  name?: string;
  entityName?: string;
  showContextHelp?: boolean;
}

export const EditFormLabel: React.FC<EditFormLabelProps> = ({ label, contextHelp, showContextHelp = true }) => {
  return (
    <div className="d-flex">
      <span className="sbb-label mr-auto">{`${label}:`}</span>
      {showContextHelp && label && contextHelp && <FormContextHelp title={label} content={contextHelp} />}
    </div>
  );
};
